import { connect } from "react-redux";

import {
  getCountryCode,
  getDefaultLanguage,
  getKeyStoreDataversion,
  getStoreCode
} from "@template/state/modules/regionalStore";
import { isLoggedIn, getFirstName } from "@template/state/modules/user";
import { buildBasicPayload } from "@template/state/modules/analytics/actions";
import { getFeature } from "@template/state/modules/features";

import ContactPreferences from "./ContactPreferences";

const mapStateToProps = state => ({
  countryCode: getCountryCode(state),
  isLoggedIn: isLoggedIn(state),
  firstName: getFirstName(state),
  gdprDeadlineCopyFeature: getFeature(state, "stc-gdpr-deadline-copy"),
  keyStoreDataversion: getKeyStoreDataversion(state),
  lang: getDefaultLanguage(state),
  storeCode: getStoreCode(state)
});

const mapDispatchToProps = {
  buildBasicPayload
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactPreferences);
